import {resultAudioContext,isSoundEnabled,getSoundVolume} from './soundEffects';

// Entirely local synthesis: no remote audio or delayed downloads at game end.
export function playResultCelebration(outcome='win'){
 let cancelled=false,master,ctx,cleanupTimer;
 const nodes=[];
 const stop=()=>{
  if(cancelled)return;cancelled=true;clearTimeout(cleanupTimer);
  for(const n of nodes){try{n.stop();}catch(_){}try{n.disconnect();}catch(_){}}
  try{master?.disconnect();}catch(_){}
  window.removeEventListener('kelimo-result-audio-stop',stop);
  document.removeEventListener('visibilitychange',hidden);
 };
 const hidden=()=>{if(document.visibilityState==='hidden')stop();};
 try{
  if(document.visibilityState==='hidden')return stop;
  ctx=resultAudioContext();if(!ctx)return stop;
  // Stop a previous result/sample before starting the next scene.
  window.dispatchEvent(new Event('kelimo-result-audio-stop'));
  window.addEventListener('kelimo-result-audio-stop',stop);
  document.addEventListener('visibilitychange',hidden);
  const requested=Date.now();
  const start=()=>{
   if(cancelled||ctx.state!=='running'||!isSoundEnabled()||getSoundVolume()===0||Date.now()-requested>1500){stop();return;}
   master=ctx.createGain();master.gain.value=getSoundVolume()*.65;master.connect(ctx.destination);
   const base=ctx.currentTime+.025;
   const note=(frequency,offset,duration,level=.12,type='triangle',endFrequency)=>{
    const osc=ctx.createOscillator(),gain=ctx.createGain();nodes.push(osc,gain);
    osc.type=type;osc.frequency.setValueAtTime(frequency,base+offset);
    if(endFrequency)osc.frequency.exponentialRampToValueAtTime(endFrequency,base+offset+duration);
    gain.gain.setValueAtTime(.0001,base+offset);gain.gain.exponentialRampToValueAtTime(level,base+offset+.018);gain.gain.exponentialRampToValueAtTime(.0001,base+offset+duration);
    osc.connect(gain);gain.connect(master);osc.start(base+offset);osc.stop(base+offset+duration+.03);
   };
   const burst=(offset,duration,level,cutoff)=>{
    const buffer=ctx.createBuffer(1,Math.ceil(ctx.sampleRate*duration),ctx.sampleRate),data=buffer.getChannelData(0);
    // Seeded noise avoids an asset dependency and keeps the authored sound repeatable.
    let seed=173;for(let i=0;i<data.length;i++){seed=(seed*16807)%2147483647;data[i]=(seed/1073741824-1)*Math.pow(1-i/data.length,2);}
    const source=ctx.createBufferSource(),filter=ctx.createBiquadFilter(),gain=ctx.createGain();nodes.push(source,filter,gain);
    source.buffer=buffer;filter.type='highpass';filter.frequency.value=cutoff;gain.gain.value=level;
    source.connect(filter);filter.connect(gain);gain.connect(master);source.start(base+offset);source.stop(base+offset+duration);
   };
   let duration;
   if(['win','reward','jackpot'].includes(outcome)){
    // Confetti cannon + low drum, brass-like rising phrase, bright final chord.
    burst(0,.38,.65,650);note(110,0,.28,.40,'sine',45);
    [[523,.12],[659,.34],[784,.56],[1047,.82],[784,1.10],[1047,1.34],[1319,1.60]].forEach(([f,t])=>{note(f,t,.40,.15,'triangle');note(f/2,t,.35,.045,'sawtooth');});
    burst(.92,.28,.32,1100);note(130,.92,.20,.24,'sine',50);
    [523,659,784,1047].forEach(f=>note(f,2.03,1.65,.10,'triangle'));
    [1568,1319,2093,1568].forEach((f,i)=>note(f,2.22+i*.22,.65,.055,'sine'));
    burst(2.05,1.40,.12,4000);duration=4.85;
    if(outcome==='jackpot'){[1047,1319,1568,2093].forEach((f,i)=>note(f,3.1+i*.2,1.4,.10,'triangle'));burst(3.1,.8,.18,2500);duration=5.4;}
    else [784,1047,1319].forEach(f=>note(f,3.2,1.2,.065,'sine'));
   }else if(outcome==='loss'){
    note(100,0,.42,.38,'sine',42);burst(0,.24,.24,180);
    [[392,.08],[330,.48],[262,.92]].forEach(([f,t])=>{note(f,t,.66,.16,'triangle');note(f/2,t,.72,.10,'sine');});
    note(196,1.36,1.05,.15,'triangle');note(130.81,1.36,1.05,.12,'sine');duration=2.55;
   }else{[523,659,784].forEach((f,i)=>note(f,i*.16,.65,.10));duration=1.15;}
   cleanupTimer=setTimeout(stop,(duration+.15)*1000);
  };
  if(ctx.state==='suspended')ctx.resume().then(start).catch(stop);else start();
 }catch(_){stop();}
 return stop;
}
